const PROCESSASSOCIATEROUTES = {
  GETPROCESSASSOCIATEROUTESCLIENTBASICANDADVANCE: `clients/client/basic/advanced/all`,
};

export default PROCESSASSOCIATEROUTES;
